import React, { useState, useEffect } from "react";
import { initGA4, initMetaPixel } from "../../utils/analytics";

const CONSENT_KEY = "das_analytics_consent";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(CONSENT_KEY);
    if (stored === "accepted") {
      initGA4();
      initMetaPixel();
    } else if (!stored) {
      setVisible(true);
    }
  }, []);

  function accept() {
    localStorage.setItem(CONSENT_KEY, "accepted");
    initGA4();
    initMetaPixel();
    setVisible(false);
  }

  function decline() {
    localStorage.setItem(CONSENT_KEY, "declined");
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      className="fixed bottom-0 left-0 right-0 z-50 border-t border-[#D4AF37]/30 bg-[#0d0b0a]/97 backdrop-blur-sm"
    >
      <div className="max-w-5xl mx-auto px-5 py-4 flex flex-col sm:flex-row sm:items-center gap-4">
        <p className="text-white/70 text-sm leading-relaxed flex-1">
          We use cookies and analytics (Google Analytics, Meta Pixel) to understand
          how visitors use this site. No personal information is collected without
          your knowledge. By clicking{" "}
          <span className="text-white/90 font-medium">Accept</span>, you consent
          to analytics tracking in accordance with{" "}
          <a
            href="/privacy-policy"
            className="text-[#D4AF37]/80 hover:text-[#D4AF37] underline underline-offset-2 transition-colors"
          >
            our privacy policy
          </a>
          .
        </p>
        <div className="flex items-center gap-3 flex-shrink-0">
          <button
            onClick={decline}
            className="px-4 py-2 text-sm text-white/60 hover:text-white/90 border border-white/20 hover:border-white/40 rounded-lg transition-colors"
          >
            Decline
          </button>
          <button
            onClick={accept}
            className="px-5 py-2 text-sm font-semibold bg-[#D4AF37] text-[#0d0b0a] hover:bg-[#D4AF37]/90 rounded-lg transition-colors"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
